import React, { useState, useEffect, useContext, useLayoutEffect, useRef } from 'react';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import animationData_Stvalentin_pulse2 from '../lotties/st-Valentin-heart-pulse_01.json';
import animationData_Stvalentin_Butterfly from '../lotties/st-Valentin-butterFly_01.json';
import animationData_Noel_tree from '../lotties/noel_Lottie_chrismasTree_01.json';
import animationData_Noel_snowflakes from '../lotties/noel_Lottie_flocons_02.json';
import animationData_NewYear_clock from '../lotties/newYear_Lottie_Clock_01.json';
import animationData_NewYear_fireWorks_01 from '../lotties/newYear_Lottie_fireWorks_02.json';
import animationData_Halloween_2 from '../lotties/halloween_Lottie_Bat_02.json';
import animationData_Halloween_3 from '../lotties/halloween_Lottie_Spider_03.json';
import animationData_Easter_ChickEgg from '../lotties/easter_Lottie_eggChick_01.json';
import animationData_STJean_Harfang from '../lotties/st_Jean_Lottie_Harfang.json';
import animationData_Default_passion_Cinema from '../lotties/passionCinema_01.json';
import animationData_CanadaDay_01 from '../lotties/cosmiqueCanadaBeaver_01.json';
import animationData_USADay_Eagle_01 from '../lotties/USA_EagleFlag_01.json';
import animationData_FranceDay_01 from '../lotties/France_Eiffel_01.json';
import animationData_FranceDay_02 from '../lotties/France_Flag_02.json';
import animationData_FranceDay_03 from '../lotties/France_Map_03.json';
import animationData_UserHoliday_ZodiacWheel from '../lotties/userHoliday_ZodiacWheel_01.json';
import Movie from './Movie.js';
import clsx from 'clsx';
import { useNavigate } from "react-router-dom";
import { UserContext } from '../UserContext';
import { RefreshContext } from '../components/RefreshContext';
import { doc, getDoc, updateDoc, getDocs, query, where, collection } from "firebase/firestore";
import { db } from '../config/firebasedeconfig';
import { useAnimationContext } from './AnimationContext';
import BackToTopButton from './BackToTopButton';
import MyParticlesComponent from './tsparticles';
import { filter } from 'minimatch';
import {
    Circle,
    Triangle,
    Rhombus,
    Parallelogram,
    Polygon,
} from 'react-awesome-shapes';
import { GradientTexture } from '@react-three/drei';
import { GreaterCompare } from 'three';
import { fill } from 'three/src/extras/TextureUtils.js';
import { useMediaQuery } from 'react-responsive'; // Importer le hook pour les requêtes média ??
import { Scale } from 'chart.js';
import notificationService from '../services/notificationService';
import 'prop-for-that/auto';

const TMDB_API_KEY =
    process.env.REACT_APP_TMDB_API_KEY;

const DIVIDER_BUBBLES = [
    { left: '5%', size: 10, duration: 6.5, delay: 0 },
    { left: '14%', size: 14, duration: 7.25, delay: 1.1 },
    { left: '23%', size: 9, duration: 6.75, delay: 0.4 },
    { left: '34%', size: 16, duration: 7.5, delay: 1.8 },
    { left: '46%', size: 11, duration: 6.25, delay: 0.9 },
    { left: '58%', size: 13, duration: 7.85, delay: 1.4 },
    { left: '69%', size: 8, duration: 6.1, delay: 0.2 },
    { left: '78%', size: 15, duration: 7.35, delay: 1.6 },
    { left: '88%', size: 12, duration: 6.9, delay: 0.7 },
    { left: '96%', size: 9, duration: 7.1, delay: 1.25 },
];


// Étape 2....
const LEVEL_UP_VISUAL_STORAGE_KEY = "mf-level-up-visual";

const LEVEL_UP_ICON = "https://zupimages.net/up/24/36/qtpo.png";

const makeLevelUpVisual = ({
    levelNumber,
    titleKey,
    levelBackground,
    levelVideoDesktop = null,
    levelVideoMobile = null,
    accent = "#D90093",
    glow = "#FF33CC",
    background = "linear-gradient(135deg, rgba(20, 2, 17, 0.95), rgba(217, 0, 147, 0.45), rgba(0, 255, 255, 0.18))",
}) => ({
    isLevelUpVisual: true,
    levelNumber,
    titleKey,
    levelBackground,
    levelVideoDesktop,
    levelVideoMobile,

    background,
    icon1: LEVEL_UP_ICON,
    dividerClass: "shapedividers_com-6191",
    dividerColor: "#00FFFF",

    borderStyle: `3px solid ${accent}`,
    titleColor: "#FFFFFF",
    titleColorVignette: accent,
    borderTitleHoliday: `5px solid ${accent}`,
    filterEffectTitleHoliday: `drop-shadow(0 0 0.35rem ${glow})`,
    iconFilterEffect: `drop-shadow(0 0 0.35rem ${glow})`,
});

// =========================================================
// DEBUG LEVEL UP
// =========================================================

// Force l'affichage d'un LevelUp précis en développement
const DEBUG_LEVEL_UP_VISUAL = false;

// Force la vidéo Premium, indépendamment de l'abonnement
// Laisser FALSE pour tester la vraie logique Free / Premium
const DEBUG_LEVEL_UP_PREMIUM_VIDEO = false;

const DEBUG_LEVEL_UP_NUMBER = 2;

const DEBUG_LEVEL_UP_KEYS = {
    1: "aspirant_figuring",          // Aspirant Figurant
    2: "cadreur_novice",             // Cadreur Novice
    3: "apprenti_monteur",           // Apprenti Monteur
    4: "assistant_realisateur",       // Assistant Réalisateur
    5: "scenariste_prometteur",       // Scénariste Prometteur
    6: "chef_operateur_illumineur",   // Chef Opérateur Illuminateur
    7: "realisateur_emerite",         // Réalisateur Émérite
    8: "maitre_mise_en_scene",        // Maître Mise en Scène
    9: "legende_7e_art",              // Légende du 7e Art
    10: "divinite_pellicule",         // Divinité de la Pellicule
};

const DEBUG_LEVEL_UP_KEY =
    DEBUG_LEVEL_UP_KEYS[DEBUG_LEVEL_UP_NUMBER] || null;

const LEVEL_UP_VISUALS = {
    aspirant_figuring: makeLevelUpVisual({
        levelNumber: 1,
        titleKey: "aspirant_figuring",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/svb3.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784397001/levelupB_01_aspirant-figurant_desktop_adno13.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784485707/levelupB_01_aspirant-figurant_mobile_ie0zpx.mp4",

        accent: "#D90093",
        glow: "#FF33CC",
    }),

    cadreur_novice: makeLevelUpVisual({
        levelNumber: 2,
        titleKey: "cadreur_novice",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/5r1h.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784402968/levelupB_02_cadreur-novice_desktop_smh9xl.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784485795/levelupB_02_cadreur-novice_mobile_x2hcqi.mp4",

        accent: "#00FFFF",
        glow: "#00FFFF",
    }),

    apprenti_monteur: makeLevelUpVisual({
        levelNumber: 3,
        titleKey: "apprenti_monteur",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/74cd.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784404594/levelupB_03_apprenti-monteur_desktop_xmhq3y.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784485900/levelupB_03_apprenti-monteur_mobile_hihnew.mp4",

        accent: "#FFB450",
        glow: "#FF33CC",
    }),

    assistant_realisateur: makeLevelUpVisual({
        levelNumber: 4,
        titleKey: "assistant_realisateur",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/yf1e.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784477080/levelupB_04_assistant-realisateur_desktop_yabuck.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784485994/levelupB_04_assistant-realisateur_mobile_zjhj8w.mp4",

        accent: "#FF33CC",
        glow: "#00FFFF",
    }),

    scenariste_prometteur: makeLevelUpVisual({
        levelNumber: 5,
        titleKey: "scenariste_prometteur",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/6bnu.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784477203/levelupB_05_scenariste-prometteur_desktop_ugk85y.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784486168/levelupB_05_scenariste-prometteur_mobile_p1msnm.mp4",

        accent: "#C084FC",
        glow: "#FFD27D",
    }),

    chef_operateur_illumineur: makeLevelUpVisual({
        levelNumber: 6,
        titleKey: "chef_operateur_illumineur",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/359x.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784477357/levelupB_06_chef-operateur-illuminateur_desktop_z4qbxk.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784488751/levelupB_06_chef-operateur-illuminateur_mobile_eh44ns.mp4",

        accent: "#FFD27D",
        glow: "#00FFFF",
    }),

    realisateur_emerite: makeLevelUpVisual({
        levelNumber: 7,
        titleKey: "realisateur_emerite",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/vesp.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784480272/levelupB_07_realisateur-emerite_desktop_ybbp5o.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784489510/levelupB_07_realisateur-emerite_mobile_ta8aai.mp4",

        accent: "#FF6A00",
        glow: "#FFD27D",
    }),

    maitre_mise_en_scene: makeLevelUpVisual({
        levelNumber: 8,
        titleKey: "maitre_mise_en_scene",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/8lhz.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784482890/levelupB_08_maitre-mise-en-scene_desktop_dbiwfk.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784489585/levelupB_08_maitre-mise-en-scene_mobile_eqwr9c.mp4",

        accent: "#A855F7",
        glow: "#FFD27D",
    }),

    legende_7e_art: makeLevelUpVisual({
        levelNumber: 9,
        titleKey: "legende_7e_art",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/ksvj.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784484044/levelupB_09_legende-7e-art_desktop_idmra7.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784490274/levelupB_09_legende-7e-art_mobile_ghfq4o.mp4",

        accent: "#FFFFFF",
        glow: "#B887FF",
    }),

    divinite_pellicule: makeLevelUpVisual({
        levelNumber: 10,
        titleKey: "divinite_pellicule",

        // Famille A - image normale
        levelBackground: "https://zupimages.net/up/26/25/8hdd.jpg",

        // Famille B - vidéo premium
        levelVideoDesktop:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784484395/levelupB_10_divinite-pellicule_desktop_kor48g.mp4",

        levelVideoMobile:
            "https://res.cloudinary.com/drhjmycvo/video/upload/v1784490384/levelupB_10_divinite-pellicule_mobile_v1iota.mp4",

        accent: "#FFD700",
        glow: "#FFFFFF",

        background:
            "linear-gradient(135deg, rgba(8, 4, 30, 0.96), rgba(120, 40, 180, 0.5), rgba(255, 215, 0, 0.25))",
    }),
};

const resolveLevelUpVisual = (payload) => {
    if (!payload) return null;

    const levelKey = payload.levelKey;
    const levelNumber = Number(payload.levelNumber);

    if (levelKey && LEVEL_UP_VISUALS[levelKey]) {
        return LEVEL_UP_VISUALS[levelKey];
    }

    return (
        Object.values(LEVEL_UP_VISUALS).find(
            (visual) => visual.levelNumber === levelNumber
        ) || null
    );
};

const readStoredLevelUpVisual = () => {
    if (typeof window === "undefined" || !window.sessionStorage) {
        return null;
    }

    try {
        const raw = window.sessionStorage.getItem(LEVEL_UP_VISUAL_STORAGE_KEY);
        if (!raw) return null;

        const payload = JSON.parse(raw);

        if (payload.expiresAt && Date.now() > payload.expiresAt) {
            window.sessionStorage.removeItem(LEVEL_UP_VISUAL_STORAGE_KEY);
            return null;
        }

        return resolveLevelUpVisual(payload);
    } catch (error) {
        console.warn("Erreur lecture visuel level_up", error);
        return null;
    }
};

const SectionsAccueil = () => {
    const { t, currentLanguage } = useLanguage();
    const { triggerAnimation } = useAnimationContext();
    const sectionRef = useRef(null);
    const [hasAnimatedA, setHasAnimatedA] = useState(false);
    const [hasAnimatedB, setHasAnimatedB] = useState(false);
    const [animationTrigger, setAnimationTrigger] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        let cancelled = false;

        const scrollFromStorage = () => {
            if (typeof window === 'undefined' || !window.sessionStorage) {
                return;
            }

            const selector = window.sessionStorage.getItem('mf-scroll-target');
            if (!selector) {
                return;
            }

            const attemptScroll = (attempts = 40, delay = 250) => {
                if (cancelled) return;
                const target = document.querySelector(selector);
                if (target) {
                    const nav = document.querySelector('.navigation');
                    const navHeight = nav ? nav.getBoundingClientRect().height : 0;
                    const extraOffset = window.innerWidth <= 992 ? 150 : 60;
                    const offset = navHeight + extraOffset;

                    const performScroll = () => {
                        const element = document.querySelector(selector);
                        if (!element) return;
                        const position = element.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({
                            top: Math.max(position, 0),
                            behavior: 'smooth'
                        });
                    };

                    const followUps = window.innerWidth <= 992 ? 3 : 1;
                    performScroll();
                    for (let i = 1; i <= followUps; i++) {
                        setTimeout(() => {
                            if (!cancelled) {
                                performScroll();
                            }
                        }, i * 500);
                    }

                    setTimeout(() => {
                        if (typeof window !== 'undefined' && window.sessionStorage) {
                            window.sessionStorage.removeItem('mf-scroll-target');
                        }
                    }, (followUps + 1) * 500);
                    return;
                }

                if (attempts > 0) {
                    setTimeout(() => attemptScroll(attempts - 1, delay), delay);
                }
            };

            attemptScroll();
        };

        scrollFromStorage();

        const handleExternalScrollRequest = () => scrollFromStorage();
        window.addEventListener('mf-scroll-section-request', handleExternalScrollRequest);

        return () => {
            cancelled = true;
            window.removeEventListener('mf-scroll-section-request', handleExternalScrollRequest);
        };
    }, []);


    useEffect(() => {
        const refreshLevelUpVisual = () => {
            const storedVisual = readStoredLevelUpVisual();

            const debugVisual =
                process.env.NODE_ENV === "development" &&
                    DEBUG_LEVEL_UP_VISUAL
                    ? LEVEL_UP_VISUALS[DEBUG_LEVEL_UP_KEY] || null
                    : null;

            setActiveLevelUpVisual(
                debugVisual || storedVisual
            );
        };

        refreshLevelUpVisual();

        window.addEventListener(
            "mf-level-up-visual-request",
            refreshLevelUpVisual
        );

        return () => {
            window.removeEventListener(
                "mf-level-up-visual-request",
                refreshLevelUpVisual
            );
        };
    }, []);

    // À ccompagner avec const DEBUG_LEVEL_UP_VIDEO = false;....

    // useEffect(() => {
    //     const refreshLevelUpVisual = () => {
    //         const storedVisual = readStoredLevelUpVisual();

    //         setActiveLevelUpVisual(
    //             DEBUG_LEVEL_UP_VIDEO
    //                 ? (storedVisual || LEVEL_UP_VISUALS.aspirant_figuring)
    //                 : storedVisual
    //         );
    //     };

    //     refreshLevelUpVisual();

    //     window.addEventListener(
    //         "mf-level-up-visual-request",
    //         refreshLevelUpVisual
    //     );

    //     return () => {
    //         window.removeEventListener(
    //             "mf-level-up-visual-request",
    //             refreshLevelUpVisual
    //         );
    //     };
    // }, []);

    // ========== SYSTÈME DE TEST POUR LES SIGNES ZODIACAUX ==========
    // Active le mode test en mettant `true` à cette variable
    const debugZodiacMode = false;
    // const debugZodiacMode = true;

    // Sélectionne le signe zodiacal à tester (décommente celui que tu veux tester)
    // const testZodiacSign = "aries";       // Bélier (21 mars - 19 avril)
    // const testZodiacSign = "taurus";      // Taureau (20 avril - 20 mai)
    // const testZodiacSign = "gemini";      // Gémeaux (21 mai - 20 juin)
    // const testZodiacSign = "cancer";      // Cancer (21 juin - 22 juillet)
    // const testZodiacSign = "leo";         // Lion (23 juillet - 22 août)
    // const testZodiacSign = "virgo";       // Vierge (23 août - 22 septembre)
    // const testZodiacSign = "libra";       // Balance (23 septembre - 22 octobre)
    // const testZodiacSign = "scorpio";     // Scorpion (23 octobre - 21 novembre)
    // const testZodiacSign = "sagittarius"; // Sagittaire (22 novembre - 21 décembre)
    // const testZodiacSign = "capricorn";  // Capricorne (22 décembre - 19 janvier)
    // const testZodiacSign = "aquarius";    // Verseau (20 janvier - 18 février)
    const testZodiacSign = "pisces";      // Poissons (19 février - 20 mars)

    // Simule une date spécifique pour tester (décommente pour tester une date précise)
    // const testDate = new Date(2024, 2, 21); // 21 mars (début Bélier)
    // const testDate = new Date(2024, 3, 20); // 20 avril (début Taureau)
    // const testDate = new Date(2024, 4, 21); // 21 mai (début Gémeaux)
    // const testDate = new Date(2024, 5, 21); // 21 juin (début Cancer)
    // const testDate = new Date(2024, 6, 23); // 23 juillet (début Lion)
    // const testDate = new Date(2024, 7, 23); // 23 août (début Vierge)
    // const testDate = new Date(2024, 8, 23); // 23 septembre (début Balance)
    // const testDate = new Date(2024, 9, 23); // 23 octobre (début Scorpion)
    // const testDate = new Date(2024, 10, 22); // 22 novembre (début Sagittaire)
    // const testDate = new Date(2024, 11, 22); // 22 décembre (début Capricorne)
    // const testDate = new Date(2024, 0, 20); // 20 janvier (début Verseau)
    const testDate = new Date(2024, 1, 19); // 19 février (début Poissons)
    // ===============================================================


    const LottieCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;  // Permet de positionner les éléments de manière précise
    width: 100%;
    height: 72.5vh;
    background-image: ${(props) => props.isUserZodiacPeriod ? `url(${props.zodiacBackground})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1 !important;
    margin-bottom: -31.5rem;
`;

    const ZodiacContainer = styled.div`
    position: absolute;
    top: 10%;  // Positionne l'image en fonction de l'écran
    right: 5%;  // Ajuste cette valeur pour positionner à droite
    display: flex;
    flex-direction: column;
    align-items: center;
`;

    // Fonction pour calculer la date de Pâques pour une année donnée
    // Utilise l'algorithme de Gauss pour le calcul de Pâques
    const calculateEaster = (year) => {
        // Algorithme de Gauss pour calculer Pâques
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;

        return new Date(year, month - 1, day);
    };

    // Fonction pour obtenir les dates de Pâques avec une période de célébration
    const getEasterPeriod = (year) => {
        const easterDate = calculateEaster(year);
        const startDate = new Date(easterDate);
        const endDate = new Date(easterDate);

        // Période de 5 jours : 2 jours avant Pâques jusqu'à 2 jours après
        startDate.setDate(startDate.getDate() - 2);
        endDate.setDate(endDate.getDate() + 2);

        return {
            startMonth: startDate.getMonth() + 1,
            startDay: startDate.getDate(),
            endMonth: endDate.getMonth() + 1,
            endDay: endDate.getDate()
        };
    };

    // States pour les films
    const [holidayFilms, setHolidayFilms] = useState([]);
    const [tendancesFilms, setTendancesFilms] = useState([]);
    const [meilleursChoixFilms, setMeilleursChoixFilms] = useState([]);
    const [saintValentin, setSaintValentin] = useState([]);
    const [currentHoliday, setCurrentHoliday] = useState('');
    const [userHolidayFilms, setUserHolidayFilms] = useState([]);
    const [currentVisual, setCurrentVisual] = useState({});
    const { userId } = useContext(UserContext);
    const { username, setUsername, isLoggedIn, userIsLoggedIn } = useContext(UserContext);
    const [userData, setUserData] = useState({});
    const { refreshNeeded, setRefreshNeeded } = useContext(RefreshContext);
    const history = useNavigate();

    const isHalloween = currentHoliday.toLowerCase() === "l'halloween";
    const isStJean = currentHoliday === "la Saint-Jean-Baptiste";
    const isEaster = currentHoliday === "la Pâques";
    const isValentine = currentHoliday === "la Saint-Valentin";
    const isFranceDay = currentHoliday === "la Fête Nationale (France)";
    const isHalloween_Cimeterry = currentHoliday.toLowerCase() === "l'halloween";
    const isIndependanceDay = currentHoliday === "la Fête Nationale (États-Unis)";
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredRight, setIsHoveredRight] = useState(false);
    const default_genre_ids = "28|12|18|35|53|878";
    // Action OU Aventure OU Drame OU Comédie OU Thriller OU Science-fiction
    const userZodiac = debugZodiacMode ? testZodiacSign : userData.zodiacSign;  // Utilise le signe de test si debug activé
    const isUserZodiacPeriod = currentHoliday === "la fête de l'utilisateur";
    const [isUserZodiacPeriodActive, setIsUserZodiacPeriodActive] = useState(false);
    const [activeLevelUpVisual, setActiveLevelUpVisual] = useState(null);

    // DEBUG: Vérifier les valeurs
    console.log('DEBUG Principal:', {
        currentHoliday,
        isUserZodiacPeriod,
        userZodiac,
        testZodiacSign,
        debugZodiacMode,
        'userData.zodiacSign': userData.zodiacSign
    });



    const [isMobileSmall, setIsMobileSmall] = useState(window.innerWidth < 481);

    // Fonction pour traduire les noms de fêtes
    const getHolidayTranslation = (holiday) => {
        const holidayMap = {
            "la passion du cinéma": t('sections.forPassionCinema'),
            "le Noël": t('sections.forChristmas'),
            "l'Halloween": t('sections.forHalloween'),
            "la Pâques": t('sections.forEaster'),
            "la Saint-Valentin": t('sections.forValentine'),
            "le Nouvel An": t('sections.forNewYear'),
            "la Fête du Canada": t('sections.forCanadaDay'),
            "la Fête Nationale (États-Unis)": t('sections.forIndependenceDay'),
            "la Fête Nationale (France)": t('sections.forBastilleDay'),
            "la Saint-Jean-Baptiste": t('sections.forStJean')
        };
        // Pour la fête de l'utilisateur, retourner une chaîne spéciale
        if (holiday === "la fête de l'utilisateur") {
            return t('sections.parceQue');
        }
        return holidayMap[holiday] || `${t('sections.pour')} ${holiday.toUpperCase()} ${t('sections.de')}`;
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleResize = () => {
                setIsMobileSmall(window.innerWidth < 1401);
            };

            window.addEventListener('resize', handleResize);
            handleResize(); // Appel initial pour définir l'état

            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);

    // Déterminez la classe de fête actuelle
    const holidayClass = currentHoliday === "l'Halloween" ? 'isHalloween' :
        currentHoliday === "la Fête Nationale (États-Unis)" ? 'isIndependenceDay' :
            currentHoliday === "la Saint-Jean-Baptiste" ? 'isStJean' :
                currentHoliday === "la Pâques" ? 'isEaster' :
                    currentHoliday === "la Saint-Valentin" ? 'isValentine' :
                        currentHoliday === "la Fête Nationale (France)" ? 'isFranceDay' :
                            '';

    const zodiacPeriods = {
        "aries": { startMonth: 3, startDay: 21, endMonth: 4, endDay: 19 },
        "taurus": { startMonth: 4, startDay: 20, endMonth: 5, endDay: 20 },
        "gemini": { startMonth: 5, startDay: 21, endMonth: 6, endDay: 20 },
        "cancer": { startMonth: 6, startDay: 21, endMonth: 7, endDay: 22 },
        "leo": { startMonth: 7, startDay: 23, endMonth: 8, endDay: 22 },
        "virgo": { startMonth: 8, startDay: 23, endMonth: 9, endDay: 22 },
        "libra": { startMonth: 9, startDay: 23, endMonth: 10, endDay: 22 },
        "scorpio": { startMonth: 10, startDay: 23, endMonth: 11, endDay: 21 },
        "sagittarius": { startMonth: 11, startDay: 22, endMonth: 12, endDay: 21 },
        "capricorn": { startMonth: 12, startDay: 22, endMonth: 1, endDay: 19 },
        "aquarius": { startMonth: 1, startDay: 20, endMonth: 2, endDay: 18 },
        "pisces": { startMonth: 2, startDay: 19, endMonth: 3, endDay: 20 }
    };

    const getZodiacTranslation = (zodiacSign) => {
        const zodiacKey = `zodiac.${zodiacSign}`;
        const translated = t(zodiacKey);

        // Ajouter l'article approprié selon la langue
        if (currentLanguage === 'fr') {
            const articles = {
                "aries": "du ",
                "taurus": "du ",
                "gemini": "du ",
                "cancer": "du ",
                "leo": "du ",
                "virgo": "de la ",
                "libra": "de la ",
                "scorpio": "du ",
                "sagittarius": "du ",
                "capricorn": "du ",
                "aquarius": "du ",
                "pisces": "des "
            };
            return articles[zodiacSign] + translated;
        } else if (currentLanguage === 'de') {
            // En allemand, on utilise le génitif "des" pour tous les signes
            return translated;
        }

        // Pour les autres langues, retourner juste le nom traduit
        return translated;
    };

    const zodiacIcons = {
        "aquarius": "https://zupimages.net/up/24/40/tl6v.png",   // Verseau ok
        "aries": "https://zupimages.net/up/24/40/b9ni.png",      // Bélier ok
        "capricorn": "https://zupimages.net/up/24/40/ymmj.png",  // Capricorne ok
        "cancer": "https://zupimages.net/up/24/40/wd4o.png",     // Cancer ok
        "gemini": "https://zupimages.net/up/24/40/tbk8.png",     // Gémeaux ok
        "leo": "https://zupimages.net/up/24/40/kwjb.png",        // Lion ok
        "libra": "https://zupimages.net/up/24/40/kow9.png",      // Balance ok
        "pisces": "https://zupimages.net/up/24/40/oza3.png",     // Poissons ok
        "sagittarius": "https://zupimages.net/up/24/40/d9jv.png",// Sagittaire ok
        "scorpio": "https://zupimages.net/up/24/40/codd.png",    // Scorpion ok
        "taurus": "https://zupimages.net/up/24/40/tuvp.png",     // Taureau ok
        "virgo": "https://zupimages.net/up/24/40/j3zu.png"       // Vierge ok
    };

    const zodiacBackgrounds = {
        "aquarius": "https://zupimages.net/up/24/39/ihhk.png", // Verseau ok
        "aries": "https://zupimages.net/up/24/39/c2zh.png", // Bélier ok
        "taurus": "https://zupimages.net/up/24/39/w3ff.png", // Taureau ok
        "gemini": "https://zupimages.net/up/24/39/79wa.png", // Gémeaux ok
        "cancer": "https://zupimages.net/up/24/40/4xeo.png", // Cancer ok
        "leo": "https://zupimages.net/up/24/40/yv51.png", // Lion ok
        "virgo": "https://zupimages.net/up/24/40/qx3f.png", // Vierge ok
        "libra": "https://zupimages.net/up/24/39/w3iz.png",  // Balance ok
        "scorpio": "https://zupimages.net/up/24/39/ybam.png", // Scorpion ok
        "sagittarius": "https://zupimages.net/up/24/39/xxy2.png", // Sagittaire ok
        "capricorn": "https://zupimages.net/up/24/39/s826.png", // Capricorne ok
        "pisces": "https://zupimages.net/up/24/39/hsyn.png" // Poissons ok
    };

    const zodiacLogoText = {
        aquarius: {
            en: "https://zupimages.net/up/24/40/hzkk.png", // Aquarius
            fr: "https://zupimages.net/up/24/40/wt8o.png", // Verseau
            es: "https://zupimages.net/up/25/25/blee.png", // Acuario
            de: "https://zupimages.net/up/25/25/cxcy.png"  // Wassermann
        },
        aries: {
            en: "https://zupimages.net/up/24/40/3t52.png", // Aries
            fr: "https://zupimages.net/up/24/40/bigw.png", // Bélier
            es: "https://zupimages.net/up/25/25/55tw.png", // Arias
            de: "https://zupimages.net/up/25/25/klic.png"  // Widder
        },
        cancer: {
            en: "https://zupimages.net/up/24/40/jeyz.png", // Cancer
            fr: "https://zupimages.net/up/24/40/jeyz.png", // Cancer (même en français)
            es: "https://zupimages.net/up/25/25/t0eu.png", // Cáncer
            de: "https://zupimages.net/up/25/25/6hzu.png"  // Krebs
        },
        capricorn: {
            en: "https://zupimages.net/up/25/25/1ssp.png", // Capricorn
            fr: "https://zupimages.net/up/25/25/fi9v.png", // Capricorne
            es: "https://zupimages.net/up/25/25/viv3.png", // Capricornio
            de: "https://zupimages.net/up/25/25/qi41.png"  // Steinbock
        },
        gemini: {
            en: "https://zupimages.net/up/24/41/r68v.png", // Gemini
            fr: "https://zupimages.net/up/24/41/7746.png", // Gémeaux
            es: "https://zupimages.net/up/25/25/2ipr.png", // Géminis
            de: "https://zupimages.net/up/25/25/2j6t.png"  // Zwillinge
        },
        leo: {
            en: "https://zupimages.net/up/24/41/100m.png", // Leo
            fr: "https://zupimages.net/up/24/41/rjkv.png", // Lion
            es: "https://zupimages.net/up/24/41/100m.png", // Leo (même en espagnol)
            de: "https://zupimages.net/up/25/25/fj7j.png"  // Löwe
        },
        libra: {
            en: "https://zupimages.net/up/24/40/6dxu.png", // Libra
            fr: "https://zupimages.net/up/24/40/iazn.png", // Balance
            es: "https://zupimages.net/up/24/40/6dxu.png", // Libra (même en espagnol)
            de: "https://zupimages.net/up/25/25/wptc.png"  // Waage
        },
        pisces: {
            en: "https://zupimages.net/up/24/41/itvm.png", // Pisces
            fr: "https://zupimages.net/up/24/41/ax0u.png", // Poissons
            es: "https://zupimages.net/up/25/25/z4ob.png", // Piscis
            de: "https://zupimages.net/up/25/25/1qxe.png"  // Fische
        },
        sagittarius: {
            en: "https://zupimages.net/up/24/41/2pga.png", // Sagittarius
            fr: "https://zupimages.net/up/24/41/kc95.png", // Sagittaire
            es: "https://zupimages.net/up/25/25/paku.png", // Sagitario
            de: "https://zupimages.net/up/25/25/q14x.png"  // Schütze
        },
        scorpio: {
            en: "https://zupimages.net/up/24/41/mizp.png", // Scorpio
            fr: "https://zupimages.net/up/24/41/dek3.png", // Scorpion
            es: "https://zupimages.net/up/25/25/zeck.png", // Escorpio
            de: "https://zupimages.net/up/25/25/p101.png"  // Skorpion
        },
        taurus: {
            en: "https://zupimages.net/up/24/41/evv5.png", // Taurus
            fr: "https://zupimages.net/up/24/41/kudl.png", // Taureau
            es: "https://zupimages.net/up/25/25/2ctd.png", // Tauro
            de: "https://zupimages.net/up/25/25/95k0.png"  // Stier
        },
        virgo: {
            en: "https://zupimages.net/up/24/41/kyz1.png", // Virgo
            fr: "https://zupimages.net/up/24/41/r4nk.png", // Vierge
            es: "https://zupimages.net/up/24/41/kyz1.png", // Virgo (même en espagnol)
            de: "https://zupimages.net/up/25/25/4xw4.png"  // Jungfrau
        }
    };

    const holidayVisuals = {
        "le Noël": {
            background: "linear-gradient(45deg, rgba(255, 255, 255, 0.8), rgba(0, 255, 255, 0.7))",
            lottie_noel_1: animationData_Noel_snowflakes,
            lottie_noel_2: animationData_Noel_tree,
            icon1: "https://zupimages.net/up/24/36/67j0.png",
            dividerClass: "shapedividers_com-8362", // Ajout de la classe pour le diviseur de Noël (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(255, 51, 204, 0.9)",
            titleColor: "#FFFFFF", // Couleur du titre pour Noël
            borderTitleHoliday: "5px solid rgba(255, 255, 255, 0.9)", // Bordure rose pour Noël (#FFFFFF)
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour le titre de Noël
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour l'icône
        },
        "l'Halloween": {
            background: "linear-gradient(45deg, rgba(0, 0, 0, 0.8), rgba(255, 95, 31, 0.7))", //Gradient Black & Neon Carrot (Orange)
            lottie_Halloween: animationData_Halloween_2,
            lottie_Halloween_2: animationData_Halloween_3,
            icon1: "https://zupimages.net/up/24/36/7zig.png",
            icon2: "https://zupimages.net/up/24/37/ppqy.png",
            dividerClass: "shapedividers_com-6475",  // Classe pour Halloween (#000000)
            dividerColor: "#000000",
            borderStyle: "3px solid rgba(255, 85, 31, 0.9)",  // Bordure pour vignette orange pour Halloween
            titleColor: "#00FFFF", // Couleur du titre pour Halloween
            titleColorVignette: "#FF5F1F", // Couleur du titre pour Halloween
            borderTitleHoliday: "5px solid rgba(0, 0, 0, 0.9)", // Bordure orange pour Halloween (#FF5F1F)
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF00FF)", // Effet de filtre pour le titre de Halloween
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF00FF)", // Effet de filtre pour l'icône de Halloween

        },
        "la Saint-Valentin": {
            background: "linear-gradient(45deg, rgba(0, 0, 0, 0.8), rgba(217, 0, 147, 0.7))",
            lottie_StValentin: animationData_Stvalentin_pulse2,
            lottie_StValentin_ButterFly: animationData_Stvalentin_Butterfly,
            icon1: "https://zupimages.net/up/23/15/bnth.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour la Saint-Valentin (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(255, 51, 204, 0.9)",  // Bordure pour vignette rose pour la Saint-Valentin
            titleColor: "#FFFFFF", // Couleur du titre pour la Saint-Valentin
            borderTitleHoliday: "5px solid rgba(255, 255, 255, 0.9)", // Bordure noire pour la Saint-Valentin (#FFFFFF)
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour le titre de la Saint-Valentin
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour l'icône de la Saint-Valentin
        },
        "la Pâques": {
            background: "linear-gradient(45deg, rgba(0, 255, 255, 0.8), rgba(255, 51, 204, 0.7))",
            lottie_Pâques: animationData_Easter_ChickEgg,
            icon1: "https://zupimages.net/up/24/36/ukrk.png",
            icon2: "https://zupimages.net/up/24/36/0333.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour Pâques (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(217, 0, 147, 0.9)",  // Bordure pour vignette rose pour Pâques
            titleColor: "#FF33CC", // Couleur du titre pour Pâques
            titleColorVignette: "#FF33CC", // Couleur du titre pour Pâques
            borderTitleHoliday: "5px solid rgba(0, 255, 255, 0.9)", // Bordure cyan pour Pâques (#00FFFF)
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FFFFFF)", // Effet de filtre pour le titre de Pâques
            iconFilterEffect: "drop-shadow(0 0 0.25rem #D90093)", // Effet de filtre pour l'icône de Pâques
        },
        "le Nouvel An": {
            background: "linear-gradient(45deg, rgba(0, 0, 0, 0.8), rgba(32, 2, 17, 0.7))",
            lottie1_NewYear: animationData_NewYear_fireWorks_01,
            lottie2_NewYear: animationData_NewYear_clock,
            icon1: "https://zupimages.net/up/24/36/7m64.png",
            icon2: "https://zupimages.net/up/24/36/p6m6.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour le Nouvel An (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(255, 51, 204, 0.9)",  // Bordure pour vignette rose pour le Nouvel An
            titleColor: "#FFFFFF", // Couleur du titre pour le Nouvel An
            borderTitleHoliday: "5px solid rgba(255, 48, 205, 0.9)", // Bordure noire pour le Nouvel An
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour le titre du Nouvel An
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour l'icône du Nouvel An
        },
        "la Saint-Jean-Baptiste": {
            background: "linear-gradient(45deg, rgba(255, 255, 255, 0.8), rgba(28, 47, 157, 0.7))",
            lottie_StJean: animationData_STJean_Harfang,
            icon1: "https://zupimages.net/up/24/36/9ga6.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour le Nouvel An (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(25, 47, 157, 0.9)",  // Bordure pour vignette bleue pour la Saint-Jean-Baptiste
            titleColor: "#FFFFFF", // Couleur du titre pour la Saint-Jean-Baptiste
            titleColorVignette: "#FFFFFF", // Couleur du titre pour la Saint-Jean-Baptiste
            borderTitleHoliday: "5px solid rgba(28, 47, 157, 0.9)", // Bordure bleue pour la Saint-Jean-Baptiste
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FFFFFF)", // Effet de filtre pour le titre de la Saint-Jean-Baptiste
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FFFFFF)", // Effet de filtre pour l'icône de la Saint-Jean-Baptiste
            iconFilterEffect_2: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour l'icône de la Saint-Jean-Baptiste
        },
        "la Fête du Canada": {
            background: "linear-gradient(45deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 99, 71, 0.7) 50%, rgba(255, 0, 0, 0.7) 100%)",
            lottie_Canada: animationData_CanadaDay_01,
            icon1: "https://zupimages.net/up/24/37/6jqx.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour le Nouvel An (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(255, 99, 71, 0.9)",  // Bordure pour vignette rouge pour la Fête du Canada
            titleColor: "#FFFFFF", // Couleur du titre pour la Fête du Canada
            titleColorVignette: "#FF6347", // Couleur du titre pour la Fête du Canada 
            borderTitleHoliday: "5px solid rgba(255, 99, 71, 0.9)", // Bordure rouge pour la Fête du Canada
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FFFFFF)", // Effet de filtre pour le titre de la Fête du Canada
            iconFilterEffect: "drop-shadow(0 0 0.20rem #FF6347) drop-shadow(0 0 0.35rem #FFFFFF)", // Effet de filtre pour l'icône de la Fête du Canada
        },
        "la Fête Nationale (États-Unis)": {
            background: "linear-gradient(135deg, rgba(239, 65, 53, 0.9) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(0, 85, 164, 0.8) 100%)",// Dégradé de couleur pour la Fête Nationale des États-Unis
            lottie_USA: animationData_USADay_Eagle_01,
            icon1: "https://zupimages.net/up/24/38/lonc.png",
            icon2: "https://zupimages.net/up/24/38/wure.png",
            dividerClass: "shapedividers_com-8362",  // Classe pour le Nouvel An (#FFFFFF)
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(0, 85, 154, 0.9)",  // Bordure pour vignette rouge pour les États-Unis
            titleColor: "#FFFFFF", // Couleur du titre pour la Fête Nationale des États-Unis
            titleColorVignette: "#FF6347", // Couleur du titre pour la Fête Nationale des États-Unis
            borderTitleHoliday: "5px solid rgba(0, 85, 164, 0.75)", // Bordure rouge pour la Fête Nationale des États-Unis
            filterEffectTitleHoliday: "drop-shadow(0 0 0.35rem #00559A)", // Effet de filtre pour le titre de la Fête Nationale des États-Unis
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF6347)", // Effet de filtre pour l'icône de la Fête Nationale des États-Unis

        },
        "la Fête Nationale (France)": {
            background: "linear-gradient(45deg, rgba(0, 85, 164, 0.9) 0%, rgba(255, 255, 255, 0.7) 50%, rgba(239, 65, 53, 0.9) 100%)",
            lottie_France_01: animationData_FranceDay_01,
            lottie_France_02: animationData_FranceDay_02,
            lottie_France_02a: animationData_FranceDay_02,
            lottie_France_03: animationData_FranceDay_03,
            icon1: "https://zupimages.net/up/24/37/9jl4.png",
            dividerClass: "shapedividers_com-6191",  // Classe pour le Nouvel An (#FFFFFF)
            dividerColor: "#00FFFF",
            borderStyle: "3px solid rgba(255, 51, 204, 0.9)",  // Bordure pour vignette bleue pour la Fête Nationale de la France
            titleColor: "#00FFFF", // Couleur du titre pour la Fête Nationale de la France
            titleColorVignette: "#00FFFF", // Couleur du titre pour la Fête Nationale de la France
            borderTitleHoliday: "5px solid rgba(255, 51, 204, 0.9)", // Bordure bleue pour la Fête Nationale de la France
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour le titre de la Fête Nationale de la France
            iconFilterEffectLeft: "drop-shadow(0 0 0.35rem #FF33CC)", // Effet de filtre pour l'icône de la Fête Nationale de la France
            iconFilterEffectRight: "drop-shadow(0 0 0.35rem #00FFFF)", // Effet de filtre pour l'icône de la Fête Nationale de la France
        },
        "le Test-Fête": {  // Utilise le même nom que celui renvoyé par getCurrentHoliday pour tester la logique
            background: "linear-gradient(45deg, rgba(255, 255, 255, 0.8), rgba(0, 255, 255, 0.7))",
            lottie1: animationData_NewYear_clock,
            lottie2: animationData_NewYear_fireWorks_01,
            icon1: "https://zupimages.net/up/23/15/bnth.png",
            dividerClass: "shapedividers_com-8362",// (#FFFFFF)
            dividerColor: "#FFFFFF",
        },
        "la fête de l'utilisateur": {
            // background: "linear-gradient(-45deg, rgba(0, 0, 0) 40%, rgba(0, 255, 255) 100%", // Dégradé de base (cyan et blanc) pour la fête de l'utilisateur
            background: "linear-gradient(135deg, rgba(20, 20, 50, 0.9), rgba(75, 0, 130, 0.7), rgba(240, 147, 251, 0.7))", // Dégradé cosmique shadow pour la fête de l'utilisateur;
            // background: "linear-gradient(135deg, rgba(15, 12, 41, 0.8) 0%, rgba(48, 43, 99, 0.8) 50%, rgba(36, 36, 62, 0.9) 100%)", // Dégradé moderne de couleur pour la fête de l'utilisateur;
            // background: "linear-gradient(120deg, rgba(240, 147, 251, 0.8), rgba(117, 58, 136, 0.7), rgba(24, 21, 64, 0.9))", // Dégradé cosmique de couleur pour la fête de l'utilisateur;
            lottie_User_ZodiacWheel: animationData_UserHoliday_ZodiacWheel,
            icon1: zodiacIcons[userZodiac] || "https://zupimages.net/up/23/15/bnth.png",  // Icône dynamique basée sur le signe du zodiaque
            dividerClass: "shapedividers_com-8362",  // Classe identique à la Saint-Valentin
            dividerColor: "#FFFFFF",
            borderStyle: "3px solid rgba(255, 51, 204, 0.9)",  // Bordure pour vignette rose
            titleColor: "#FFFFFF", // Couleur du titre pour la fête de l'utilisateur
            borderTitleHoliday: "5px solid rgba(255, 255, 255, 0.9)", // Bordure blanche
            filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour le titre
            iconFilterEffect: "drop-shadow(0 0 0.25rem #FF33CC)", // Effet de filtre pour l'icône
        },
    };

    // Définir une valeur par défaut pour les visuels
    const defaultVisual = {
        background: "linear-gradient(-45deg, rgba(255, 255, 255, 0.8), rgba(255, 51, 204, 0.7))", // Dégradé de couleur par défaut #FFFFFF et #FF33CC
        lottie_default: animationData_Default_passion_Cinema, // Animation par défaut
        icon1: "https://zupimages.net/up/24/36/qtpo.png",  // Icone par défaut
        dividerClass: "shapedividers_com-981", // Classe par défaut pour le diviseur #200211
        dividerColor: "#200211",
        borderStyle: "3px solid rgba(32, 2, 17, 0.9)",  // Bordure par défaut pour vignette #200211
        titleColor: "#FFFFFF", // Couleur du titre par défaut
        titleColorVignette: "#D90093", // Couleur du titre pour la vignette par défaut
        borderTitleHoliday: "5px solid rgba(32, 2, 17, 0.9)", // Bordure par défaut pour le titre #FF33CC
        filterEffectTitleHoliday: "drop-shadow(0 0 0.25rem #200211)", // Effet de filtre par défaut pour le titre
        iconFilterEffect: "drop-shadow(0 0 0.25rem #00FFFF)", // Effet de filtre par défaut pour l'icôn
    };

    useEffect(() => {
        // Vérifier si l'utilisateur est connecté et dans sa période zodiacale
        const isUserInZodiacPeriod = isLoggedIn && isUserZodiacPeriod;
        setIsUserZodiacPeriodActive(isUserInZodiacPeriod);
    }, [isLoggedIn, isUserZodiacPeriod]);

    useEffect(() => {
        const fetchUserData = async () => {
            if (!userId || !isLoggedIn) return;

            try {
                const userRef = doc(db, 'users', userId);
                const docSnap = await getDoc(userRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setUserData(data);
                    // Tu récupères bien les autres informations ici comme zodiacSign
                } else {
                    console.log('Aucune donnée utilisateur trouvée pour cet ID');
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données de l'utilisateur:", error);
            }
        };

        fetchUserData();
    }, [userId, isLoggedIn]);

    const getCurrentHoliday = (userLocation) => {
        const today = debugZodiacMode && testDate ? testDate : new Date();
        const currentYear = today.getFullYear();

        // Calculer la période de Pâques pour l'année courante
        const easterPeriod = getEasterPeriod(currentYear);

        const holidays = [
            // { name: "le Noël", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17},
            { name: "le Noël", startMonth: 12, startDay: 23, endMonth: 12, endDay: 27 },
            // { name: "l'Halloween", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17},
            { name: "l'Halloween", startMonth: 10, startDay: 29, endMonth: 11, endDay: 2 },
            // Pâques avec calcul dynamique
            { name: "la Pâques", ...easterPeriod },
            // { name: "la Pâques", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17},
            // { name: "la Saint-Valentin", startMonth: 6, startDay: 25, endMonth: 6, endDay: 29},
            { name: "la Saint-Valentin", startMonth: 2, startDay: 12, endMonth: 2, endDay: 16 },
            // { name: "le Nouvel An", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17},
            { name: "le Nouvel An", startMonth: 12, startDay: 30, endMonth: 1, endDay: 2 },
            // { name: "la Fête du Canada", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17, location: "Canada" },
            { name: "la Fête du Canada", startMonth: 6, startDay: 29, endMonth: 7, endDay: 3, location: "Canada" },
            // { name: "la Fête Nationale (France)", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17, location: "France" },
            { name: "la Fête Nationale (France)", startMonth: 7, startDay: 12, endMonth: 7, endDay: 16, location: "France" },
            // { name: "la Fête Nationale (États-Unis)", startMonth: 6, startDay: 16, endMonth: 6, endDay: 20, location: "États-Unis" },
            { name: "la Fête Nationale (États-Unis)", startMonth: 7, startDay: 4, endMonth: 7, endDay: 6, location: "États-Unis" },
            // Je dois présicer que la fête de la Saint-Jean-Baptiste est une fête nationale au Canada, mais elle est célébrée uniquement au Québec          
            // { name: "la Saint-Jean-Baptiste", startMonth: 8, startDay: 11, endMonth: 8, endDay: 17, location: "Canada" },
            { name: "la Saint-Jean-Baptiste", startMonth: 6, startDay: 21, endMonth: 6, endDay: 27, location: "Canada" },
            //J'invente temporairement une fête qui correspond à oujourd'hui juste pour tester si la logique prend bien effet..
            // { name: "le Test-Fête", startMonth: 6, startDay: 13, endMonth: 6, endDay: 17},
            // Nouvelle entrée pour l'anniversaire de l'utilisateur, couvrant tout le mois
            {
                name: "la fête de l'utilisateur",
                startMonth: debugZodiacMode ? 6 : userData.birthMonth,  // En mode debug, utiliser décembre pour Capricorne
                startDay: 1,
                endMonth: debugZodiacMode ? 6 : userData.birthMonth,
                endDay: 31
            },
        ];

        // Debug Holiday Mode: Si activé, forcer la date à une date spécifique pour tester les périodes de vacances
        const debugHolidayMode = false; // Mettre à true pour activer le mode de test des vacances
        if (debugHolidayMode && testDate) {
            const testMonth = testDate.getMonth() + 5; // Les mois sont basés sur 0, donc ajouter 1. Exemple +5 = juin. Donc, la Saint-Jean-Baptiste.
            const testDay = testDate.getDate();

            // Vérifier si la date de test correspond à une période de vacances
            const testHoliday = holidays.find(holiday => {
                const { startMonth, startDay, endMonth, endDay } = holiday;
                return (testMonth === startMonth && testDay >= startDay) ||
                    (testMonth === endMonth && testDay <= endDay) ||
                    (testMonth > startMonth && testMonth < endMonth);
            });

            if (testHoliday) {
                return testHoliday.name;
            }
        }






        const isTodayInHolidayRange = (holiday) => {
            const { startMonth, startDay, endMonth, endDay } = holiday;
            const spansYear = endMonth < startMonth || (endMonth === startMonth && endDay < startDay);

            if (!spansYear) {
                const startDate = new Date(currentYear, startMonth - 1, startDay);
                const endDate = new Date(currentYear, endMonth - 1, endDay);
                return today >= startDate && today <= endDate;
            }

            // Gère correctement les périodes qui traversent le Nouvel An (ex: 30 déc 2025 -> 2 jan 2026)
            const currentSpanStart = new Date(currentYear, startMonth - 1, startDay);
            const currentSpanEnd = new Date(currentYear + 1, endMonth - 1, endDay);
            const previousSpanStart = new Date(currentYear - 1, startMonth - 1, startDay);
            const previousSpanEnd = new Date(currentYear, endMonth - 1, endDay);

            return (today >= previousSpanStart && today <= previousSpanEnd) ||
                (today >= currentSpanStart && today <= currentSpanEnd);
        };

        const currentHoliday = holidays.find(isTodayInHolidayRange);

        return currentHoliday ? currentHoliday.name : "la passion du cinéma";
    };

    const fetchFilmsForHoliday = async (holiday) => {
        let genreIdsArray = [];
        let additionalFilters = '';
        let additionalFiltersQuebec = '';

        switch (holiday) {
            case "le Noël":
                genreIdsArray = "35,14,10751"; // Comédie, Fantastique, Familial
                break;
            case "l'Halloween":
                genreIdsArray = "27,53"; // Horreur, Thriller
                break;
            case "la Pâques":
                genreIdsArray = "16,10751"; // Animation, Familial
                break;
            case "la Saint-Valentin":
                genreIdsArray = "10749"; // Romance
                break;
            case "le Nouvel An":
                genreIdsArray = "35,18,12"; // Comédie, Drame, Aventure
                break;
            case "la Fête du Canada":
                genreIdsArray = ['']; // Aventure, Drame, Histoire
                additionalFilters = "&with_origin_country=CA";
                break;
            case "la Fête Nationale (États-Unis)":
                genreIdsArray = ['']; // Action, Aventure, Histoire, Western
                additionalFilters = "&with_origin_country=US"; // Filtres pour films américains
                break;
            case "la Fête Nationale (France)":
                genreIdsArray = ['']; // Histoire, Drame, Action
                additionalFilters = "&with_origin_country=FR";// Filtres pour films français
                break;
            case "la Saint-Jean-Baptiste":
                genreIdsArray = ['']; // Pas de genre spécifique pour la Saint-Jean-Baptiste
                additionalFilters = "&with_origin_country=CA"; // Filtres pour films québécois, région canadiens
                additionalFiltersQuebec = "&with_original_language=fr"; // Filtres pour films québécois, filtre langue française
                break;
            case "le Test-Fête":
                genreIdsArray = "53,12,35"; // Thriller, Aventure, Comédie
                break;
            default:
                genreIdsArray = default_genre_ids; // Utilise le genre par défaut si aucun genre n'est trouvé
                break;
        }

        const currentVisual = holidayVisuals[currentHoliday] || defaultVisual;

        const today = new Date().toISOString().slice(0, 10);
        const lastTenYears = new Date().getFullYear() - 10;

        let languageParam =
            currentLanguage === 'en'
                ? 'en-US'
                : `${currentLanguage}-${currentLanguage.toUpperCase()}`;

        let fallbackLanguage = '';

        if (currentLanguage === 'de' || currentLanguage === 'es') {
            fallbackLanguage = ',en-US';
        }

        const url =
            `https://api.themoviedb.org/3/discover/movie` +
            `?api_key=${TMDB_API_KEY}` +
            `&language=${languageParam}${fallbackLanguage}` +
            `${additionalFilters}${additionalFiltersQuebec}` +
            `&with_genres=${genreIdsArray}` +
            `&release_date.lte=${today}` +
            `&release_date.gte=${lastTenYears}-01-01` +
            `&sort_by=popularity.desc` +
            `&include_adult=false` +
            `&page=1` +
            `&include_video=false`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (
                data.results.length === 0 &&
                currentLanguage !== 'fr' &&
                currentLanguage !== 'en'
            ) {
                const fallbackUrl = url.replace(
                    `language=${languageParam}${fallbackLanguage}`,
                    'language=en-US'
                );

                const fallbackResponse = await fetch(fallbackUrl);
                const fallbackData = await fallbackResponse.json();

                return fallbackData.results.slice(0, 20);
            }

            return data.results.slice(0, 20);

        } catch (error) {
            console.error(
                `Erreur lors de la récupération des films pour ${holiday}:`,
                error
            );

            return [];
        }
    };

    const fetchFilmsForUserHoliday = async () => {
        const favoriteGenreIds =
            Array.isArray(userData.favoriteCategories) &&
                userData.favoriteCategories.length > 0
                ? userData.favoriteCategories
                    .slice(0, 3)
                    .map((category) => category.id)
                    .filter(Boolean)
                    .join('|')
                : default_genre_ids;

        const languageParam =
            currentLanguage === 'en'
                ? 'en-US'
                : `${currentLanguage}-${currentLanguage.toUpperCase()}`;

        const url =
            `https://api.themoviedb.org/3/discover/movie` +
            `?api_key=${TMDB_API_KEY}` +
            `&language=${languageParam}` +
            `&with_genres=${favoriteGenreIds}` +
            `&sort_by=popularity.desc` +
            `&include_adult=false` +
            `&include_video=false` +
            `&page=1`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            const filmsWithPoster = (data.results || []).filter(
                (film) => film.poster_path
            );

            setHolidayFilms(filmsWithPoster.slice(0, 20));

        } catch (error) {
            console.error(
                "Erreur lors de la récupération des films pour la fête de l'utilisateur :",
                error
            );
        }
    };



    useEffect(() => {
        const holiday = getCurrentHoliday(userData.location || '');
        setCurrentHoliday(holiday);
    }, [userData]);



    // Fonction qui vérifie si une fête majeure est en cours avant de prioriser la fête de l'utilisateur
    const getCurrentHolidayWithPriority = () => {
        const userLocation = userData.location || '';
        const holiday = getCurrentHoliday(userLocation);

        // Priorité aux fêtes majeures
        if (holiday === "l'Halloween" || holiday === "le Noël" || holiday === "la Pâques" || holiday === "la Saint-Valentin" ||
            holiday === "le Nouvel An" || holiday === "la Fête du Canada" || holiday === "la Fête Nationale (États-Unis)" ||
            holiday === "la Fête Nationale (France)" || holiday === "la Saint-Jean-Baptiste") {
            return holiday; // Si une fête majeure est en cours, elle est prioritaire
        }

        // Si aucune fête majeure, on regarde la fête de l'utilisateur
        const userHoliday = getUserHoliday();
        if (userHoliday) {
            return userHoliday; // Si la fête de l'utilisateur est en cours, elle est utilisée
        }

        // Retour par défaut si aucune fête n'est active
        return "la passion du cinéma";
    };

    const getUserHoliday = () => {
        const today = debugZodiacMode && testDate ? testDate : new Date();
        const currentMonth = today.getMonth() + 1; // Les mois sont 0-indexés en JavaScript
        const currentDay = today.getDate();

        const userZodiac = debugZodiacMode ? testZodiacSign : userData.zodiacSign;

        // Vérifier si la date actuelle tombe dans la période du signe de l'utilisateur
        if (userZodiac && zodiacPeriods[userZodiac]) {
            const { startMonth, startDay, endMonth, endDay } = zodiacPeriods[userZodiac];

            let startDate = new Date(today.getFullYear(), startMonth - 1, startDay);
            let endDate = new Date(today.getFullYear(), endMonth - 1, endDay);

            // 🔄 Si la période traverse l'année (ex: Capricorne), on ajuste les années
            if (endMonth < startMonth || (endMonth === startMonth && endDay < startDay)) {
                // Capricorne typiquement
                if (today.getMonth() + 1 < startMonth) {
                    // On est en janvier
                    startDate.setFullYear(startDate.getFullYear() - 1);
                } else {
                    // On est en décembre
                    endDate.setFullYear(endDate.getFullYear() + 1);
                }
            }

            const isUserHoliday = today >= startDate && today <= endDate;
            if (isUserHoliday) return "la fête de l'utilisateur";
        }


        return null; // Pas de fête de l'utilisateur pour cette date
    };

    useEffect(() => {
        const holiday = getCurrentHolidayWithPriority();
        setCurrentHoliday(holiday);

        const fetchFilms = async () => {
            if (holiday === "la fête de l'utilisateur") {
                await fetchFilmsForUserHoliday();
            } else {
                const films = await fetchFilmsForHoliday(holiday);
                setHolidayFilms(films);
            }
        };

        fetchFilms();
    }, [userData, currentLanguage]);



    useEffect(() => {
        const isHolidayOrZodiacActive =
            currentHoliday && currentHoliday !== "la passion du cinéma";

        const visual =
            !isHolidayOrZodiacActive && activeLevelUpVisual
                ? activeLevelUpVisual
                : holidayVisuals[currentHoliday] || defaultVisual;

        console.log("Current visual applied:", {
            currentHoliday,
            isHolidayOrZodiacActive,
            activeLevelUpVisual,
            visual,
        });

        setCurrentVisual(visual);
    }, [currentHoliday, activeLevelUpVisual]);

    // Neutralise les petits blocs cyan résiduels (ex: carré turquoise) tout en loggant ce qui a été touché
    useEffect(() => {
        if (!sectionRef.current) return;

        const neutralized = [];
        const candidates = sectionRef.current.querySelectorAll('*');

        candidates.forEach((el) => {
            const style = window.getComputedStyle(el);
            const bg = style.backgroundColor || '';
            if (!bg.includes('0, 255, 255')) return; // cible uniquement le cyan

            const rect = el.getBoundingClientRect();
            if (rect.width <= 120 && rect.height <= 120) {
                el.style.backgroundColor = 'transparent';
                el.style.boxShadow = 'none';
                el.style.border = 'none';
                neutralized.push({
                    tag: el.tagName,
                    className: el.className,
                    bg,
                    width: rect.width,
                    height: rect.height
                });
            }
        });

        if (neutralized.length) {
            console.log('Neutralized cyan blocks:', neutralized);
        }
    }, [currentHoliday]);



    useEffect(() => {
        const fetchTendancesFilms = async () => {
            const languageParam =
                currentLanguage === 'en'
                    ? 'en-US'
                    : `${currentLanguage}-${currentLanguage.toUpperCase()}`;

            const url =
                `https://api.themoviedb.org/3/trending/movie/week` +
                `?api_key=${TMDB_API_KEY}` +
                `&language=${languageParam}`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                const filmsWithPoster = (data.results || []).filter(
                    (film) => film.poster_path
                );

                setTendancesFilms(filmsWithPoster.slice(0, 20));
            } catch (error) {
                console.error(
                    "Erreur lors de la récupération des tendances TMDB :",
                    error
                );
            }
        };

        fetchTendancesFilms();
    }, [currentLanguage]);

    useEffect(() => {
        const fetchMeilleursChoixFilms = async () => {
            const languageParam =
                currentLanguage === 'en'
                    ? 'en-US'
                    : `${currentLanguage}-${currentLanguage.toUpperCase()}`;

            const hasFavoriteGenres =
                isLoggedIn &&
                Array.isArray(userData.favoriteCategories) &&
                userData.favoriteCategories.length > 0;

            const favoriteGenreIds = hasFavoriteGenres
                ? userData.favoriteCategories
                    .slice(0, 3)
                    .map((category) => category.id)
                : [];

            const today = new Date().toISOString().slice(0, 10);

            // On élargit légèrement la période pour ne pas pénaliser
            // des genres moins prolifiques comme le Western.
            const twelveYearsAgo = new Date();
            twelveYearsAgo.setFullYear(
                twelveYearsAgo.getFullYear() - 12
            );

            const fromDate =
                twelveYearsAgo.toISOString().slice(0, 10);

            const fetchGenrePool = async (genreId) => {
                const url =
                    `https://api.themoviedb.org/3/discover/movie` +
                    `?api_key=${TMDB_API_KEY}` +
                    `&language=${languageParam}` +
                    `&with_genres=${genreId}` +
                    `&primary_release_date.gte=${fromDate}` +
                    `&primary_release_date.lte=${today}` +
                    `&vote_count.gte=100` +
                    `&vote_average.gte=6.2` +
                    `&sort_by=popularity.desc` +
                    `&include_adult=false` +
                    `&include_video=false` +
                    `&page=1`;

                const response = await fetch(url);
                const data = await response.json();

                return (data.results || []).filter(
                    (film) => film.poster_path
                );
            };

            try {
                // Aucun genre favori :
                // on garde la sélection généraliste.
                if (favoriteGenreIds.length === 0) {
                    const genericFilms =
                        await fetchGenrePool(default_genre_ids);

                    setMeilleursChoixFilms(
                        genericFilms.slice(0, 20)
                    );

                    return;
                }

                // Une requête TMDB indépendante par genre favori.
                const genrePools = await Promise.all(
                    favoriteGenreIds.map((genreId) =>
                        fetchGenrePool(genreId)
                    )
                );

                // Fusionner les pools sans doublons.
                const mergedFilms = [];
                const seenIds = new Set();

                genrePools.forEach((pool) => {
                    pool.forEach((film) => {
                        if (!seenIds.has(film.id)) {
                            seenIds.add(film.id);
                            mergedFilms.push(film);
                        }
                    });
                });

                setMeilleursChoixFilms(mergedFilms);

            } catch (error) {
                console.error(
                    "Erreur lors de la récupération des meilleurs choix :",
                    error
                );
            }
        };

        fetchMeilleursChoixFilms();
    }, [
        currentLanguage,
        isLoggedIn,
        userData.favoriteCategories
    ]);


    useLayoutEffect(() => {
        const elementsA = document.querySelectorAll('.section-1, .section-3_default');
        const elementsB = document.querySelectorAll('.section-2');

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(entry.target.classList.contains('section-1') || entry.target.classList.contains('section-3_default') ? 'animate-translateSectionA' : 'animate-translateSectionB');
                } else {
                    entry.target.classList.remove('animate-translateSectionA', 'animate-translateSectionB');
                }
            });
        };

        const observerOptions = { threshold: 0.5 };
        const observer = new IntersectionObserver(observerCallback, observerOptions);

        elementsA.forEach(el => observer.observe(el));
        elementsB.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, [triggerAnimation]);

    // Vérifier si l'utilisateur est dans sa période zodiacale et envoyer une notification
    useEffect(() => {
        const checkZodiacPeriod = async () => {
            if (!isLoggedIn || !userId || !userData.zodiacSign) {
                return;
            }

            const today = new Date();
            const currentMonth = today.getMonth() + 1; // Les mois sont 0-indexés en JavaScript
            const currentDay = today.getDate();

            const userZodiac = userData.zodiacSign;

            // Vérifier si la date actuelle tombe dans la période du signe de l'utilisateur
            if (zodiacPeriods[userZodiac]) {
                const { startMonth, startDay, endMonth, endDay } = zodiacPeriods[userZodiac];

                // Calculer les dates de début et de fin de la période
                const currentYear = today.getFullYear();
                const startDate = new Date(currentYear, startMonth - 1, startDay);
                let endDate = new Date(currentYear, endMonth - 1, endDay);

                // Gérer le cas où la période s'étend sur deux années (ex. Capricorne)
                if (endMonth < startMonth) {
                    endDate.setFullYear(currentYear + 1);
                }

                // Vérifier si aujourd'hui est le premier jour de la période du signe
                const isFirstDay =
                    (currentMonth === startMonth && currentDay === startDay);

                // Vérifier si nous sommes dans la période zodiacale
                const isWithinPeriod =
                    (today >= startDate && today <= endDate);

                if (isWithinPeriod) {
                    // Vérifier si une notification zodiacale existe déjà dans le panneau
                    // Si l'utilisateur l'a supprimée, on peut en créer une nouvelle
                    try {
                        const recentNotifications = await checkForRecentZodiacNotifications(userId, userZodiac);

                        if (!recentNotifications) {
                            // Créer une notification pour la période zodiacale
                            await notificationService.createZodiacPeriodNotification(
                                userId,
                                userData.username || "Utilisateur",
                                getZodiacTranslation(userZodiac) || userZodiac,
                                startDate,
                                endDate
                            );

                            console.log(`Notification zodiacale créée pour ${userData.username}`);

                            // Mettre à jour l'utilisateur pour indiquer que la notification a été envoyée
                            // Note: Avec la nouvelle logique, ce champ est moins pertinent mais gardé pour compatibilité
                            try {
                                const userRef = doc(db, 'users', userId);
                                await updateDoc(userRef, {
                                    zodiacNotified: true,
                                    lastZodiacNotification: new Date()
                                });
                            } catch (updateError) {
                                console.error("Erreur lors de la mise à jour du statut de notification zodiacale:", updateError);
                            }
                        }
                    } catch (error) {
                        console.error("Erreur lors de la création de la notification zodiacale:", error);
                    }
                }

                // Réinitialiser le drapeau de notification à la fin de la période
                if (today > endDate && userData.zodiacNotified) {
                    try {
                        const userRef = doc(db, 'users', userId);
                        await updateDoc(userRef, {
                            zodiacNotified: false,
                            lastZodiacNotification: null
                        });
                    } catch (error) {
                        console.error("Erreur lors de la réinitialisation du statut de notification zodiacale:", error);
                    }
                }
            }
        };

        checkZodiacPeriod();
    }, [isLoggedIn, userId, userData, isUserZodiacPeriodActive]);

    // Vérifier s'il existe déjà une notification zodiacale récente
    const checkForRecentZodiacNotifications = async (userId, zodiacSign) => {
        try {
            // On vérifie simplement s'il existe une notification active pour ce signe
            // Si l'utilisateur l'a supprimée, on peut en créer une nouvelle
            return await notificationService.hasActiveZodiacNotification(userId, zodiacSign);
        } catch (error) {
            console.error("Erreur lors de la vérification des notifications zodiacales récentes:", error);
            return false;
        }
    };

    // Vérifier s'il faut envoyer une notification pour une fête spéciale
    useEffect(() => {
        const checkHolidayPeriod = async () => {
            if (!isLoggedIn || !userId || !userData.username) {
                return;
            }

            const holiday = getCurrentHoliday(userData.location || '');

            // Si c'est une fête spéciale (différente de la passion du cinéma et de la fête de l'utilisateur)
            if (holiday !== "la passion du cinéma" && holiday !== "la fête de l'utilisateur") {
                try {
                    // Vérifier si une notification pour cette fête existe déjà dans le panneau
                    // Si l'utilisateur l'a supprimée, on peut en créer une nouvelle
                    const recentHolidayNotification = await checkForRecentHolidayNotifications(userId, holiday);

                    if (!recentHolidayNotification) {
                        // Créer une notification pour la fête
                        await notificationService.createHolidayNotification(
                            userId,
                            userData.username || "Utilisateur",
                            holiday
                        );

                        console.log(`Notification de fête "${holiday}" créée pour ${userData.username}`);

                        // Mettre à jour l'utilisateur pour indiquer que la notification a été envoyée
                        // Note: Avec la nouvelle logique, ce champ est moins pertinent mais gardé pour compatibilité
                        try {
                            const userRef = doc(db, 'users', userId);
                            await updateDoc(userRef, {
                                lastHolidayNotified: holiday,
                                holidayNotifiedDate: new Date()
                            });
                        } catch (updateError) {
                            console.error("Erreur lors de la mise à jour du statut de notification de fête:", updateError);
                        }
                    }
                } catch (error) {
                    console.error("Erreur lors de la création de la notification de fête:", error);
                }
            }
        };

        checkHolidayPeriod();
    }, [isLoggedIn, userId, userData, currentHoliday]);

    // Vérifier s'il existe déjà une notification de fête récente
    const checkForRecentHolidayNotifications = async (userId, holidayName) => {
        try {
            // On vérifie simplement s'il existe une notification active pour cette fête
            // Si l'utilisateur l'a supprimée, on peut en créer une nouvelle
            return await notificationService.hasActiveHolidayNotification(userId, holidayName);
        } catch (error) {
            console.error("Erreur lors de la vérification des notifications de fête récentes:", error);
            return false;
        }
    };

    // const isLevelUpVisualActive =
    //     Boolean(activeLevelUpVisual) &&
    //     currentHoliday === "la passion du cinéma";

    // const activeLevelUpTitle = isLevelUpVisualActive
    //     ? t(
    //         `forum.levelTitles.${activeLevelUpVisual.titleKey}`,
    //         activeLevelUpVisual.titleKey
    //     )
    //     : "";

    const isLevelUpVisualActive =
        Boolean(activeLevelUpVisual) &&
        currentHoliday === "la passion du cinéma";

    const activeLevelUpTitle = isLevelUpVisualActive
        ? t(
            `forum.levelTitles.${activeLevelUpVisual.titleKey}`,
            activeLevelUpVisual.titleKey
        )
        : "";

    const subscription = userData?.subscription;

    const hasPremiumLevelUpVideo =
        isLoggedIn &&
        subscription?.status === "active" &&
        ["cinephile", "fanatic"].includes(subscription?.planId);

    const isLevelUpVideoDebug =
        process.env.NODE_ENV === "development" &&
        DEBUG_LEVEL_UP_PREMIUM_VIDEO;

    const useLevelUpVideo =
        (isLevelUpVideoDebug || hasPremiumLevelUpVideo) &&
        isLevelUpVisualActive &&
        Boolean(activeLevelUpVisual?.levelVideoDesktop);

    const section3UserName = isLoggedIn
        ? userData.username
        : t('sections.tous');

    const renderSection3Title = () => {
        if (isLevelUpVisualActive) {
            return (
                <>
                    {t('sections.levelUpRankIntro', 'Félicitations, votre rang est désormais')}{" "}
                    <span style={{ color: activeLevelUpVisual.titleColorVignette || "#D90093" }}>
                        {activeLevelUpTitle}
                    </span>
                    ,{" "}
                    <span style={{ color: "#00FFFF" }}>
                        {section3UserName}
                    </span>
                    {" "}!
                </>
            );
        }

        const baseTitle = (() => {
            if (currentHoliday === "la Fête Nationale (France)") {
                return t('sections.titleForBastilleDay');
            }

            if (currentHoliday === "la fête de l'utilisateur") {
                return t('sections.parceQue');
            }

            return getHolidayTranslation(currentHoliday);
        })();

        const zodiacPart = currentHoliday === "la fête de l'utilisateur"
            ? (() => {
                const zodiacTranslated = t(`zodiac.${userZodiac}`);
                let finalTranslation = zodiacTranslated;

                if (currentLanguage === 'fr') {
                    const articles = {
                        aries: "du ",
                        taurus: "du ",
                        gemini: "du ",
                        cancer: "du ",
                        leo: "du ",
                        virgo: "de la ",
                        libra: "de la ",
                        scorpio: "du ",
                        sagittarius: "du ",
                        capricorn: "du ",
                        aquarius: "du ",
                        pisces: "des ",
                    };

                    finalTranslation = `${articles[userZodiac] || ""}${zodiacTranslated}`;
                }

                return `, ${t('sections.nousEnPeriode')} ${finalTranslation}, ${t('sections.celebronsAnniversaire')}`;
            })()
            : "";

        const userPart = isLoggedIn
            ? ` ${userData.username}`
            : currentHoliday === "la Fête Nationale (France)"
                ? ""
                : ` ${t('sections.tous')}`;

        return (
            <>
                {baseTitle}
                <span style={{ color: "#00FFFF" }}>
                    {userPart}
                </span>
                {zodiacPart}
            </>
        );
    };

    // =========================================================
    // FILMS UNIQUES ENTRE LES 3 SECTIONS D'ACCUEIL
    // Priorité : Tendances -> Meilleurs choix -> Section 3
    // =========================================================

    const usedMovieIds = new Set();

    const takeUniqueMovies = (movies, limit = 8) => {
        const selectedMovies = [];

        for (const film of movies) {
            if (!film?.id || usedMovieIds.has(film.id)) {
                continue;
            }

            usedMovieIds.add(film.id);
            selectedMovies.push(film);

            if (selectedMovies.length === limit) {
                break;
            }
        }

        return selectedMovies;
    };

    const displayedTendancesFilms =
        takeUniqueMovies(tendancesFilms);


    // =========================================================
    // MEILLEURS CHOIX PERSONNALISÉS
    // Minimum par genre + redistribution automatique
    // =========================================================

    const favoriteGenreIdsForDisplay =
        isLoggedIn &&
            Array.isArray(userData.favoriteCategories)
            ? userData.favoriteCategories
                .slice(0, 3)
                .map((category) => Number(category.id))
            : [];


    const takeBalancedFavoriteMovies = (
        movies,
        genreIds,
        limit = 8
    ) => {
        const selectedMovies = [];
        const localIds = new Set();

        const addMovie = (film) => {
            if (
                !film?.id ||
                usedMovieIds.has(film.id) ||
                localIds.has(film.id)
            ) {
                return false;
            }

            localIds.add(film.id);
            usedMovieIds.add(film.id);
            selectedMovies.push(film);

            return true;
        };


        // 3 genres → minimum 2 films par genre.
        // 2 genres → minimum 3 films par genre.
        // 1 genre  → minimum 6 films.
        const minimumPerGenre =
            genreIds.length >= 3
                ? 2
                : genreIds.length === 2
                    ? 3
                    : 6;


        // Réserver d'abord une présence à chaque genre favori.
        for (const genreId of genreIds) {
            let addedForGenre = 0;

            for (const film of movies) {
                if (
                    Array.isArray(film.genre_ids) &&
                    film.genre_ids.includes(genreId)
                ) {
                    if (addMovie(film)) {
                        addedForGenre++;
                    }
                }

                if (
                    addedForGenre >= minimumPerGenre ||
                    selectedMovies.length >= limit
                ) {
                    break;
                }
            }
        }


        // Compléter les places restantes par popularité.
        const remainingMovies = [...movies].sort(
            (a, b) =>
                (b.popularity || 0) -
                (a.popularity || 0)
        );

        for (const film of remainingMovies) {
            if (selectedMovies.length >= limit) {
                break;
            }

            addMovie(film);
        }

        return selectedMovies;
    };


    const displayedMeilleursChoixFilms =
        favoriteGenreIdsForDisplay.length > 0
            ? takeBalancedFavoriteMovies(
                meilleursChoixFilms,
                favoriteGenreIdsForDisplay
            )
            : takeUniqueMovies(meilleursChoixFilms);


    const displayedHolidayFilms =
        takeUniqueMovies(holidayFilms);

    return (

        <div className="sections-accueil" ref={sectionRef}>
            <div className="section-1 row shapedividers_com-6191">
                <div className="col-12 sectionCol-1">
                    <div className="content-container">
                        <div className="title-container">
                            <div className="title-border">
                                <h2 className="title-text no-border" id='titleMoment'>{t('sections.tendances')} <span style={{ color: "#00FFFF" }}>{isLoggedIn ? userData.username : t('sections.tous')}</span></h2>
                            </div>
                        </div>
                        <div className="movie-grid">
                            {displayedTendancesFilms.map((film) => (
                                <Movie
                                    key={film.id}
                                    movie={film}
                                    onClickMovie={() => history(`/ficheFilm/${film.id}`)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-2 row shapedividers_com-7773">
                <div className="col-12 sectionCol-2">
                    <div className="title-container">
                        <div className="title-border">
                            <h2 className="title-text no-border" id='titleChoix' style={{ zIndex: '10' }}>{t('sections.meilleursChoix')} <span style={{ color: "#00FFFF" }}>{isLoggedIn ? userData.username : t('sections.tous')}</span></h2>
                        </div>
                    </div>
                    <div className="movie-grid">
                        {displayedMeilleursChoixFilms.map((film) => (
                            <Movie
                                key={film.id}
                                movie={film}
                                onClickMovie={() => history(`/ficheFilm/${film.id}`)}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div
                className={clsx(
                    'section-3_default',
                    'row',
                    currentVisual.dividerClass,
                    {
                        'section-3_level-up': isLevelUpVisualActive,
                    }
                )}
                style={{
                    background: currentVisual.background,
                    '--divider-bubble-color': currentVisual.dividerColor || '#FF33CC',
                    '--level-up-accent': isLevelUpVisualActive
                        ? activeLevelUpVisual?.titleColorVignette || '#D90093'
                        : currentVisual.dividerColor || '#FF33CC',
                }}
            >
                <div className="divider-bubbles" aria-hidden="true">
                    {DIVIDER_BUBBLES.map((bubble, index) => (
                        <span
                            key={`divider-bubble-${index}`}
                            style={{
                                left: bubble.left,
                                width: `${bubble.size}px`,
                                height: `${bubble.size}px`,
                                animationDuration: `${bubble.duration}s`,
                                animationDelay: `${bubble.delay}s`
                            }}
                        />
                    ))}
                </div>
                <div className="col-12 sectionCol-3">
                    <div className="section3content">
                        <div className="section-3-title">
                            <div className="title-container"
                                style={{
                                    color: holidayVisuals[currentHoliday]?.borderTitleHoliday,
                                    transform: isHalloween ? "translateY(-2vh)" : "none",
                                }}
                            >
                                <Lottie
                                    animationData={currentVisual.lottie_Halloween_2} // Araignée
                                    loop={true}
                                    autoplay={true}
                                    className={clsx('lottie-halloween-spider', {
                                        'isHalloween': isHalloween,
                                    })}
                                    style={{
                                        transform: "scale(1.55)",
                                        width: "10vw",
                                        height: "3.5.5vh",
                                        top: "7.5vh",
                                        left: "10.25vw",
                                        zIndex: 5001,
                                        pointerEvents: "none",
                                        position: "absolute",
                                        display: isHalloween ? "block" : "none"
                                    }}
                                />
                                <div
                                    className={clsx('title-border_B', {
                                        'holiday-title-color': holidayVisuals[currentHoliday]?.titleColor,
                                        'default-title-color': !holidayVisuals[currentHoliday]?.titleColor,
                                    })}
                                    id="holidayBorder"
                                    style={{
                                        border: holidayVisuals[currentHoliday]?.borderTitleHoliday || defaultVisual.borderTitleHoliday,
                                        filter: holidayVisuals[currentHoliday]?.filterEffectTitleHoliday || defaultVisual.filterEffectTitleHoliday,
                                    }}
                                >
                                    {/* <h2 className="title-text no-border" id="titleValentin" style={{
                                        color: holidayVisuals[currentHoliday]?.titleColor,
                                    }}>
                                        {(() => {
                                            if (currentHoliday === "la Fête Nationale (France)") {
                                                return t('sections.titleForBastilleDay');
                                            }
                                            if (currentHoliday === "la fête de l'utilisateur") {
                                                return t('sections.parceQue');
                                            }
                                            return getHolidayTranslation(currentHoliday);
                                        })()}
                                        <span style={{ color: "#00FFFF" }}>
                                            {isLoggedIn ? ` ${userData.username}` : (currentHoliday === "la Fête Nationale (France)" ? "" : ` ${t('sections.tous')}`)}
                                        </span>
                                        {currentHoliday === "la fête de l'utilisateur"
                                            ? (() => {
                                                // Utiliser directement t() pour la traduction
                                                const zodiacTranslated = t(`zodiac.${userZodiac}`);
                                                let finalTranslation = zodiacTranslated;

                                                // Ajouter l'article selon la langue
                                                if (currentLanguage === 'fr') {
                                                    const articles = {
                                                        "aries": "du ",
                                                        "taurus": "du ",
                                                        "gemini": "du ",
                                                        "cancer": "du ",
                                                        "leo": "du ",
                                                        "virgo": "de la ",
                                                        "libra": "de la ",
                                                        "scorpio": "du ",
                                                        "sagittarius": "du ",
                                                        "capricorn": "du ",
                                                        "aquarius": "du ",
                                                        "pisces": "des "
                                                    };
                                                    finalTranslation = articles[userZodiac] + zodiacTranslated;
                                                }

                                                console.log('DEBUG Titre Zodiac Direct:', {
                                                    userZodiac,
                                                    zodiacTranslated,
                                                    finalTranslation,
                                                    currentLanguage
                                                });

                                                return `, ${t('sections.nousEnPeriode')} ${finalTranslation}, ${t('sections.celebronsAnniversaire')}`;
                                            })()
                                            : ""}
                                    </h2> */}
                                    <h2
                                        className="title-text no-border"
                                        id="titleValentin"
                                        style={{
                                            color: isLevelUpVisualActive
                                                ? "#FFFFFF"
                                                : holidayVisuals[currentHoliday]?.titleColor,
                                        }}
                                    >
                                        {renderSection3Title()}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={clsx('col-12 col-md-12 zoddiacAndLottieContainer', {
                        'user-zodiac-period': isUserZodiacPeriodActive,
                    })}
                    style={{ zIndex: 5000 }}
                >
                    <div
                        className={clsx(
                            'iconWithLottie d-flex justify-content-between align-items-center',
                            holidayClass,
                            {
                                'user-zodiac-period': isUserZodiacPeriodActive,
                                'is-level-up-visual': isLevelUpVisualActive,
                            }
                        )}
                        style={{
                            padding: isLevelUpVisualActive
                                ? "8vh 0 4vh"
                                : isUserZodiacPeriod
                                    ? "10vh 0"
                                    : "0",
                        }}
                    >
                        {/* <!-- Icon à gauche --> */}
                        <img
                            src={currentVisual.icon1}
                            alt="iconHolidayLeft"
                            className={clsx('_iconHoliday', 'iconMarkLeft', {
                                isEasterStyle: isEaster,
                                isValentineStyle: isValentine,
                                isFranceDayStyle: isFranceDay,
                                'hovered-style': isHovered,
                                'independance-day-opacity': isIndependanceDay && !isHovered,
                                'iconMarkLeft-hovered': isHovered,
                                'user-zodiac-period': isUserZodiacPeriodActive,
                                'is-level-up-visual': isLevelUpVisualActive,
                            })}
                            style={{
                                background: currentVisual.icon1 === defaultVisual.icon1
                                    ? (isHovered ? 'linear-gradient(45deg, rgba(255, 255, 255, 0.8), rgba(0, 255, 255, 0.7))' : '#9795C6')
                                    : 'none',
                                borderRadius: currentVisual.icon1 === defaultVisual.icon1 ? '50%' : 'none',
                                padding: currentVisual.icon1 === defaultVisual.icon1 ? '10px' : '0',
                                marginLeft: "1vw",
                                zIndex: 10,
                                overflow: 'visible',
                                opacity: isHovered ? 0.75 : (isIndependanceDay ? 0.35 : 1),
                                transition: "transform 0.3s ease-in-out", // Garder la transition ici ou la déplacer dans le CSS
                                // transform: isMobileSmall ? 'scale(0.65)' : 'scale(1)',
                                filter: isLevelUpVisualActive
                                    ? currentVisual.iconFilterEffect
                                    : currentHoliday === "la Saint-Jean-Baptiste"
                                        ? (isHovered ? currentVisual.iconFilterEffect_2 : currentVisual.iconFilterEffect)
                                        : currentHoliday === "la Fête Nationale (France)"
                                            ? (isHovered ? currentVisual.iconFilterEffectRight : "none")
                                            : (isHovered ? currentVisual.iconFilterEffect : "none")
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        />
                        {/* <!-- Lotties centrées --> */}
                        <div
                            id="id_iconHoliday"
                            className={clsx('lottieCenter', holidayClass, {
                                halloweenStyle: isHalloween,
                                isStJeanStyle: isStJean,
                                isEasterStyle: isEaster,
                                isValentineStyle: isValentine,
                                isFranceDayStyle: isFranceDay,
                                isIndependanceDayStyle: isIndependanceDay,
                                isUserZodiacPeriod: isUserZodiacPeriod,
                                'user-zodiac-period': isUserZodiacPeriodActive,
                                'is-level-up-visual': isLevelUpVisualActive,
                            })}
                        >
                            {isLevelUpVisualActive && (
                                <div
                                    className="level-up-stage"
                                    style={{
                                        '--level-up-accent': activeLevelUpVisual.titleColorVignette || '#D90093',
                                    }}
                                >
                                    {useLevelUpVideo ? (
                                        <div
                                            className="level-up-stage__image-wrap level-up-stage__video-wrap"
                                            data-props-for="video-color"
                                        >
                                            <video
                                                key={activeLevelUpVisual.levelNumber}
                                                className="level-up-stage__video"
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                crossOrigin="anonymous"
                                                preload="metadata"
                                            >
                                                {activeLevelUpVisual.levelVideoMobile && (
                                                    <source
                                                        media="(max-width: 768px)"
                                                        src={activeLevelUpVisual.levelVideoMobile}
                                                        type="video/mp4"
                                                    />
                                                )}

                                                <source
                                                    src={activeLevelUpVisual.levelVideoDesktop}
                                                    type="video/mp4"
                                                />
                                            </video>

                                            <span className="level-up-stage__shine" />
                                        </div>
                                    ) : (
                                        <div
                                            className="level-up-stage__image-wrap"
                                            style={{
                                                backgroundImage: `
                linear-gradient(
                    180deg,
                    rgba(20, 2, 17, 0.04),
                    rgba(20, 2, 17, 0.26)
                ),
                url(${activeLevelUpVisual.levelBackground})
            `,
                                            }}
                                        >
                                            <span className="level-up-stage__shine" />
                                        </div>
                                    )}

                                    <div className="level-up-stage__badge">
                                        <span className="level-up-stage__eyebrow">
                                            {t('sections.levelLabel', 'Niveau')} {activeLevelUpVisual.levelNumber}
                                        </span>

                                        <span className="level-up-stage__title">
                                            <span className="level-up-stage__number">
                                                {activeLevelUpVisual.levelNumber}
                                            </span>
                                            {activeLevelUpTitle}
                                        </span>
                                    </div>
                                </div>
                            )}
                            <img
                                src={zodiacBackgrounds[userZodiac]}
                                alt={`Background for ${userZodiac}`}
                                className={clsx('zodiacImgMobile', {
                                    isUserZodiacPeriod: isUserZodiacPeriod,
                                })}
                                style={{
                                    display: isMobileSmall && (isUserZodiacPeriod || debugZodiacMode) ? 'block' : 'none',
                                    zIndex: 1,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    transform: 'scale(0.85)', // Ajuste le scale si besoin
                                }}
                            />
                            {/* mode mobile */}
                            <ZodiacContainer>
                                {console.log('DEBUG Zodiac Image:', {
                                    userZodiac,
                                    debugZodiacMode,
                                    testZodiacSign,
                                    currentLanguage,
                                    zodiacLogoTextExists: !!zodiacLogoText[userZodiac],
                                    allZodiacKeys: Object.keys(zodiacLogoText),
                                    imageUrl: zodiacLogoText[userZodiac]?.[currentLanguage],
                                    fallbackUrl: zodiacLogoText[userZodiac]?.fr,
                                    allUrls: zodiacLogoText[userZodiac]
                                })}
                                <img
                                    src={zodiacLogoText[userZodiac]?.[currentLanguage] || zodiacLogoText[userZodiac]?.fr}
                                    alt={`Logo Text for ${userZodiac}`}
                                    className={clsx('zodiac-logo-text', {
                                        isUserZodiacPeriod: isUserZodiacPeriod || debugZodiacMode,
                                        'user-zodiac-period': isUserZodiacPeriodActive || debugZodiacMode,
                                        isMobileSmall: isMobileSmall,
                                    })}
                                    style={{ width: '22.5rem', height: 'auto', marginTop: '-2.5rem', marginRight: '-2vw', transform: 'rotate(3.5deg)', zIndex: 10000, display: isMobileSmall && (isUserZodiacPeriod || debugZodiacMode) ? 'block' : 'none' }}
                                />
                            </ZodiacContainer>
                            {/* Ici tu affiches la roue Zodiac */}
                            {(isUserZodiacPeriod || debugZodiacMode) && (
                                <LottieCenter
                                    isUserZodiacPeriod={isUserZodiacPeriod}
                                    zodiacBackground={zodiacBackgrounds[userZodiac]}
                                    className={clsx('dynamic-border', {
                                        isUserZodiacPeriod: isUserZodiacPeriod,
                                        'user-zodiac-period': isUserZodiacPeriodActive, // Ajouter une classe pour la période du zodiaque de l'utilisateur
                                    })}
                                    style={{
                                        display: isMobileSmall ? 'none' : 'block',
                                    }}
                                >
                                    {/* mode Pc */}
                                    <ZodiacContainer>
                                        <img
                                            src={zodiacLogoText[userZodiac]?.[currentLanguage] || zodiacLogoText[userZodiac]?.fr}
                                            alt={`Logo Text for ${userZodiac}`}
                                            className={clsx('zodiac-logo-text', {
                                                isUserZodiacPeriod: isUserZodiacPeriod,
                                                'user-zodiac-period': isUserZodiacPeriodActive, // Ajouter une classe pour la période du zodiaque de l'utilisateur
                                                isMobileSmall: isMobileSmall,
                                            })}
                                            style={{ width: '22.5rem', height: 'auto', marginTop: '-2.5rem', marginRight: '-1.7vw', transform: 'rotate(3.5deg)', zIndex: 10000, display: isMobileSmall && (isUserZodiacPeriod || debugZodiacMode) ? 'none' : 'block' }}
                                        />
                                    </ZodiacContainer>
                                </LottieCenter>
                            )}
                            {/* <LottieCenter isUserZodiacPeriod={isUserZodiacPeriod} zodiacBackground={zodiacBackgrounds[userZodiac]}>
                                {isUserZodiacPeriod && (
                                    <ZodiacContainer>
                                        <Circle
                                            color="#ff00ff"  // Couleur du cercle (peut être ajustée)
                                            size={['300px', '300px']}  // Taille ajustée
                                            zIndex={5}  // Plus élevé pour s'assurer qu'il est visible
                                            position="absolute"
                                            top="50px"  // Ajustement de la position pour qu'il soit visible
                                            left="50px"
                                            animation={{
                                                type: 'rotate',  // Animation de rotation
                                                duration: 10,  // Durée en secondes
                                                timingFunction: 'linear',  // Animation fluide
                                            }}
                                        />
                                        <img
                                            src={zodiacLogoText[userZodiac]?.[currentLanguage] || zodiacLogoText[userZodiac]?.fr}
                                            alt={`Logo Text for ${userZodiac}`}
                                            style={{
                                                width: '22.5rem',
                                                height: 'auto',
                                                marginTop: '-2.5rem',
                                                marginRight: '-2vw',
                                                transform: 'rotate(3.5deg)',
                                            }}  // Style pour le logo texte
                                        />
                                    </ZodiacContainer>
                                )}
                            </LottieCenter> */}
                            {/* <LottieCenter
                                isUserZodiacPeriod={isUserZodiacPeriod}
                                zodiacBackground={zodiacBackgrounds[userZodiac]}
                            >
                            </LottieCenter> */}
                            {isIndependanceDay && (
                                <div
                                >
                                    <MyParticlesComponent />
                                </div>
                            )}
                            <img
                                src={currentVisual.icon2}
                                alt="iconHolidayCimetierre"
                                className={clsx('_iconHoliday', {
                                    'icon-cimetery': isHalloween_Cimeterry,
                                })}
                                style={{
                                    transform: "scale(4.25)",
                                    zIndex: 40,
                                    position: "relative",
                                    top: "32.5vh",
                                    left: "-1.75vw",
                                    pointerEvents: "none",
                                    display: isHalloween_Cimeterry ? "block" : "none",
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie1}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.85)"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie2}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.85)"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_noel_1}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(2.85)",
                                    marginTop: "8.5vh",
                                    zIndex: 20,
                                    position: "relative",
                                    top: "10vh"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_noel_2}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.55)",
                                    marginBottom: "-12vh",
                                    zIndex: 10,
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_default}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.5)",
                                    zIndex: 10,
                                    top: "22.5vh",
                                    // top: "-24.5vh",
                                    position: "relative"
                                }}
                                className={clsx('lottieCenterMobile', holidayClass)}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_StJean}
                                loop={true}
                                autoplay={true}
                                className={clsx({
                                    'lottie-stjean': currentHoliday === "la Saint-Jean-Baptiste",
                                })}
                                style={{
                                    transform: "scale(0.25)",
                                    zIndex: 10,
                                    top: "-25.5vh",
                                    position: "relative",
                                    marginTop: "-7.5vh"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_Pâques}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.75)",
                                    zIndex: 10,
                                    top: "26.5vh",
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_StValentin}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(1.25)",
                                    zIndex: 10,
                                    top: "37.5vh",
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_StValentin_ButterFly}
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(1.25)",
                                    zIndex: 5,
                                    top: "-47.5vh",
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie2_NewYear} // horloge
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.4)",
                                    zIndex: 20,
                                    top: "12.5vh",
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie1_NewYear} // feux d'artifice
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.55)",
                                    zIndex: 10,
                                    top: "-55vh",
                                    position: "relative"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_Canada} // Cosmique Castor
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.55)",
                                    top: "12.5vh",
                                    position: "relative",
                                    zIndex: 10
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_Halloween} // Chauve-souris
                                loop={true}
                                autoplay={true}
                                className={clsx('lottie-halloween-bat', {
                                    'isHalloween': isHalloween,
                                })}
                                style={{
                                    transform: "scale(0.85)",
                                    top: "12.5vh",
                                    zIndex: 10,
                                    pointerEvents: "none",
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_France_01} // Tour Eiffel
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.5)",
                                    top: "19.5vh",
                                    zIndex: 10,
                                    pointerEvents: "none",
                                    position: "relative",
                                    filter: "drop-shadow(0px 0px 12px rgba(255, 255, 255, 0.8))"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_France_02} // Drapeau droit
                                loop={true}
                                autoplay={true}
                                className='lottie-france-flagRight'
                                style={{
                                    transform: "scale(0.22) rotate(45deg)",
                                    top: "-22vh",
                                    left: "9.25vw",
                                    zIndex: -55,
                                    pointerEvents: "none",
                                    position: "relative",
                                    filter: "drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.8))",
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_France_02a} // Drapeau gauche
                                loop={true}
                                autoplay={true}
                                className='lottie-france-flagLeft'
                                style={{
                                    transform: "scale(0.22) rotate(-45deg) scaleX(-1)",
                                    top: "-64.5vh",
                                    left: "-9.25vw",
                                    zIndex: -55,
                                    pointerEvents: "none",
                                    position: "relative",
                                    filter: "drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.8))"
                                }}
                            />
                            <Lottie
                                animationData={currentVisual.lottie_France_03} // Carte
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.3875)",
                                    top: "-123.55vh",
                                    zIndex: -50,
                                    pointerEvents: "none",
                                    position: "relative",
                                    border: "3em solid #00FFFF",
                                    borderRadius: "25%",
                                    filter: "drop-shadow(0px 0px 10px rgba(255, 255, 255, 0.6))"
                                }}
                            />
                            {/* <Lottie
                                animationData={currentVisual.lottie_User_ZodiacWheel} // Roue des signes du zodiaque
                                loop={true}
                                autoplay={true}
                                style={{
                                    transform: "scale(0.75)",
                                    // top: "11.5vh",
                                    position: "relative",
                                    zIndex: 10

                                }}
                            /> */}
                            <div
                                className={clsx('zodiac-wheel-container', {
                                    isMobileSmall: isMobileSmall,
                                    isUserZodiacPeriod: isUserZodiacPeriod,
                                    'user-zodiac-period': isUserZodiacPeriodActive,
                                })}
                                style={{
                                    display: (isUserZodiacPeriod || debugZodiacMode) ? 'block' : 'none',
                                }}
                            >
                                <div className="zodiac-wheel-wrapper" style={{
                                    transform: 'scale(1.2)', // Agrandir légèrement la roue
                                    transition: 'transform 0.5s ease-in-out',
                                }}>
                                    <img
                                        src="https://zupimages.net/up/24/39/2xjv.png"
                                        alt="Zodiac Wheel"
                                        className="zodiac-wheel"
                                        style={{
                                            opacity: isUserZodiacPeriod ? 0.45 : 0,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <!-- Icon à droite --> */}
                        <img
                            src={currentVisual.icon1}
                            alt="iconHolidayRight"
                            className={clsx('_iconHoliday', 'iconMarkRight', {
                                'hovered-style': isHoveredRight,
                                'independance-day-opacity': isIndependanceDay && !isHoveredRight,
                                'iconMarkRight-hovered': isHoveredRight,
                                'user-zodiac-period': isUserZodiacPeriodActive,
                                'is-level-up-visual': isLevelUpVisualActive,
                            })}
                            style={{
                                background: currentVisual.icon1 === defaultVisual.icon1
                                    ? (isHoveredRight ? 'linear-gradient(45deg, rgba(255, 255, 255, 0.8), rgba(0, 255, 255, 0.7))' : '#9795C6')
                                    : 'none',
                                borderRadius: currentVisual.icon1 === defaultVisual.icon1 ? '50%' : 'none',
                                padding: currentVisual.icon1 === defaultVisual.icon1 ? '10px' : '0',
                                marginRight: "1vw",
                                zIndex: 10,
                                overflow: 'visible',
                                opacity: isHoveredRight ? 0.75 : (isIndependanceDay ? 0.35 : 1),
                                transition: "transform 0.3s ease-in-out", // Garder la transition ici ou la déplacer dans le CSS
                                filter: isLevelUpVisualActive
                                    ? currentVisual.iconFilterEffect
                                    : currentHoliday === "la Saint-Jean-Baptiste"
                                        ? (isHoveredRight ? currentVisual.iconFilterEffect_2 : currentVisual.iconFilterEffect)
                                        : currentHoliday === "la Fête Nationale (France)"
                                            ? (isHoveredRight ? currentVisual.iconFilterEffectRight : "none")
                                            : (isHoveredRight ? currentVisual.iconFilterEffect : "none")
                            }}
                            onMouseEnter={() => setIsHoveredRight(true)}
                            onMouseLeave={() => setIsHoveredRight(false)}
                        />
                    </div>
                </div>
                <div className={clsx('movie-grid mv3', {
                    'user-zodiac-period': isUserZodiacPeriodActive,
                })}>
                    {displayedHolidayFilms.length > 0 ? (
                        displayedHolidayFilms.map((film) => (
                            <Movie
                                key={film.id}
                                movie={film}
                                additionalClass={clsx('movie-card', {
                                    'hovered-shadow_movie_grill': isHovered,
                                })}
                                titleColor={
                                    currentVisual.titleColorVignette ||
                                    holidayVisuals[currentHoliday]?.titleColorVignette
                                }
                                onClickMovie={() => history(`/ficheFilm/${film.id}`)}
                                borderStyle={
                                    currentVisual.borderStyle ||
                                    holidayVisuals[currentHoliday]?.borderStyle
                                }
                            />
                        ))
                    ) : (
                        <div
                            style={{
                                textAlign: 'center',
                                padding: '2rem',
                                color:
                                    holidayVisuals[currentHoliday]?.titleColor ||
                                    '#FFFFFF',
                            }}
                        >
                            <p>{t('sections.aucunFilm')}</p>

                            {(currentLanguage === 'de' ||
                                currentLanguage === 'es') && (
                                    <p
                                        style={{
                                            fontSize: '0.9rem',
                                            marginTop: '1rem',
                                            opacity: 0.8,
                                        }}
                                    >
                                        {currentLanguage === 'de'
                                            ? 'Für mehr Inhalte können Sie die Sprache in der Navigation auf Englisch oder Französisch umstellen.'
                                            : 'Para más contenido, puede cambiar el idioma a inglés o francés en la navegación.'}
                                    </p>
                                )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SectionsAccueil;
